// Loads the persisted Stacks word list (frontend/public/dictionaries/
// wordy-whiz-stacks.json, generated by scripts/generate-stacks-dictionary.js)
// once and exposes a synchronous, O(1) membership check against it — no
// network round-trip per drop.

let dictSet = null;
let loadingPromise = null;

export function loadDictionary() {
  if (dictSet) return Promise.resolve(dictSet);
  if (loadingPromise) return loadingPromise;
  loadingPromise = fetch('/dictionaries/wordy-whiz-stacks.json')
    .then((res) => {
      if (!res.ok) throw new Error(`Failed to load dictionary: ${res.status}`);
      return res.json();
    })
    .then((words) => {
      dictSet = new Set(words);
      return dictSet;
    })
    .catch((err) => {
      loadingPromise = null; // allow retry
      throw err;
    });
  return loadingPromise;
}

export function isDictionaryReady() {
  return dictSet !== null;
}

export function isValidWord(word) {
  return dictSet !== null && dictSet.has(word);
}
